<template>
  <RevInputSelect
    :id="id"
    v-bind="$attrs"
    v-model="selectedCountry"
    data-cs-mask
    :label="i18n(translations.label)"
    :options="options"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputSelect } from '@ds/components/InputSelect'

import { NATIONALITIES } from '../../../constants'

import translations from './InputAddressNationality.translations'

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(defineProps<{ id?: string; value: string }>(), {
  id: 'nationality',
})

const i18n = useI18n()

const selectedCountry = ref(props.value)

const options = computed(() =>
  Object.entries(NATIONALITIES)
    .map(([value, labelTranslation]) => ({
      value,
      label: i18n(labelTranslation),
    }))
    .sort((a, b) => {
      return a.label < b.label ? -1 : 1
    }),
)
</script>
